var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getApiUrl } from "./apiEndPoints";
// Use the same API URL resolution as the rest of the app
const BASE_URL = getApiUrl().replace("/api/v1/", ""); // Remove the API prefix for direct calls
const fetchData = (endpoint) => __awaiter(void 0, void 0, void 0, function* () {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 3000); // 3 seconds timeout
    try {
        const response = yield fetch(endpoint, { signal: controller.signal });
        if (!response.ok) {
            throw new Error(`Failed to fetch data from ${endpoint}`);
        }
        return yield response.json();
    }
    catch (error) {
        if (error instanceof Error && error.name === "AbortError") {
            throw new Error(`Request to ${endpoint} timed out`);
        }
        throw error;
    }
    finally {
        clearTimeout(timeoutId);
    }
});
export const getTrials = () => __awaiter(void 0, void 0, void 0, function* () {
    //convert to TrialModel[]
    const data = yield cleanJsonString(yield fetchData(`${BASE_URL}/api/v1/Ptn/trials`));
    return (yield JSON.parse(data));
});
const cleanJsonString = (jsonString) => {
    return jsonString.replace(/\\n/g, "").replace(/\\"/g, '"');
};
export const getSites = () => __awaiter(void 0, void 0, void 0, function* () {
    const data = yield cleanJsonString(yield fetchData(`${BASE_URL}/api/v1/Ptn/sites`));
    return (yield JSON.parse(data));
});
// return from preset data until api is ready
export const getRainfall = () => __awaiter(void 0, void 0, void 0, function* () {
    const data = [
        {
            RainfallID: 1,
            Name: "Very Low 0-200 mm",
            RainfallMinMm: 0,
            RainfallMaxMm: 200,
        },
        {
            RainfallID: 2,
            Name: "Low 201 - 300 mm",
            RainfallMinMm: 201,
            RainfallMaxMm: 300,
        },
        {
            RainfallID: 3,
            Name: "Medium 301 - 450mm",
            RainfallMinMm: 301,
            RainfallMaxMm: 450,
        },
        {
            RainfallID: 4,
            Name: "Medium - High 451 - 600",
            RainfallMinMm: 451,
            RainfallMaxMm: 600,
        },
        {
            RainfallID: 5,
            Name: "High 601 - 800",
            RainfallMinMm: 601,
            RainfallMaxMm: 800,
        },
    ];
    return data;
});
